import React, { useState } from 'react';
import { trackEvent, BOOKING_SCREENING_URL, BOOKING_THERAPY_URL, BOOKING_SUPERVISION_URL } from '../lib/tracking';
import SatisfactionGuaranteeModal from '../components/SatisfactionGuaranteeModal';

export default function Pricing() {
  const [activeTab, setActiveTab] = useState('terapi');
  const [isGuaranteeOpen, setIsGuaranteeOpen] = useState(false);

  const therapyPrices = [
    {
      title: 'Individuel psykoterapi',
      price: '1.200 kr.',
      duration: '60 min. pr. session',
      desc: 'Professionel samtale, NLP og kropslig regulering tilpasset din konkrete udfordring (stress, angst, krise, selvværd, traumer).',
      conditions: 'Betaling ved sessionens afslutning. Afbud senest 24 timer før.',
      popular: false,
      bookingUrl: BOOKING_THERAPY_URL,
    },
    {
      title: 'Klippekort – 5 sessioner',
      price: '5.000 kr.',
      duration: '5 x 60 min. (Spar 1.000 kr.)',
      desc: 'Det mest valgte forløb for vedvarende forandring og tryg opfølgning. Giver 1.000 kr. i samlet besparelse.',
      conditions: 'Betales ved første session. Skal anvendes inden for 12 måneder fra købsdatoen.',
      popular: true,
      bookingUrl: BOOKING_THERAPY_URL,
    },
    {
      title: 'Studerende, unge under 25 & pensionister',
      price: '800 kr.',
      duration: '60 min. pr. session',
      desc: 'Særlig reduceret takst for studerende med gyldigt studiekort, unge under 25 år samt folkepensionister.',
      conditions: 'Fremvisning af dokumentation/studiekort ved første møde.',
      popular: false,
      bookingUrl: BOOKING_THERAPY_URL,
    },
  ];

  const hypnosisPrices = [
    {
      title: 'Individuel hypnoterapi',
      price: '1.200 kr.',
      duration: '60 min. pr. session',
      desc: 'Professionel hypnoterapi tilpasset din konkrete udfordring (traumer, automatiske reaktioner, indre uro eller vaner).',
      conditions: 'Betaling ved sessionens afslutning. Afbud senest 24 timer før.',
      popular: false,
      badge: 'Enkeltsession',
      bookingUrl: BOOKING_THERAPY_URL,
    },
    {
      title: 'Klippekort – 5 sessioner',
      price: '5.000 kr.',
      duration: '5 x 60 min. (Spar 1.000 kr.)',
      desc: 'Det mest valgte forløb for vedvarende forandring og tryg opfølgning. Giver 1.000 kr. i samlet besparelse.',
      conditions: 'Betales ved første session. Skal anvendes inden for 12 måneder fra købsdatoen.',
      popular: true,
      badge: 'Klippekort',
      bookingUrl: BOOKING_THERAPY_URL,
    },
    {
      title: 'Studerende, unge under 25 & pensionister',
      price: '800 kr.',
      duration: '60 min. pr. session',
      desc: 'Særlig reduceret takst for studerende med gyldigt studiekort, unge under 25 år samt folkepensionister.',
      conditions: 'Fremvisning af dokumentation/studiekort ved første møde.',
      popular: false,
      badge: 'Særtilbud',
      bookingUrl: BOOKING_THERAPY_URL,
    },
    {
      title: 'Slip nikotin med hypnose',
      price: '3.000 kr.',
      duration: '2-3 sessioner (inkl. moms)',
      desc: 'Stop med cigaretter, snus, vaping og andre nikotinvaner. Dybdegående omprogrammering af de ubevidste triggere.',
      conditions: 'Fast pakkepris for hele forløbet.',
      popular: false,
      badge: 'Målrettet pakke',
      bookingUrl: BOOKING_THERAPY_URL,
    },
    {
      title: 'Sæt forbrændingen op med hypnose',
      price: '3.000 kr.',
      duration: '2-3 sessioner (inkl. moms)',
      desc: 'Slip sukkertrang, fede sager, junk food og uhensigtsmæssig overspisning. Genfind naturlig mæthedsfølelse.',
      conditions: 'Fast pakkepris for hele forløbet.',
      popular: false,
      badge: 'Målrettet pakke',
      bookingUrl: BOOKING_THERAPY_URL,
    },
  ];

  const supervisionPrices = [
    {
      title: 'Individuel supervision',
      price: '1.500 kr.',
      duration: '60 min. pr. session',
      desc: 'Faglig supervision for uddannede psykoterapeuter, lærere, pædagoger og andre faggrupper med menneskeligt ansvar.',
      conditions: 'Fokus på relationer, etik, nervesystem og forebyggelse af udbrændthed.',
      popular: false,
      bookingUrl: BOOKING_SUPERVISION_URL,
    },
    {
      title: 'Supervision for NLP-studerende',
      price: '933 kr.',
      duration: '60 min. pr. session',
      desc: 'Særlig takst for studerende under godkendt psykoterapeutuddannelse på Dansk NLP Institut.',
      conditions: 'Gyldig til dokumentation for uddannelseskrav.',
      popular: false,
      bookingUrl: BOOKING_SUPERVISION_URL,
    },
    {
      title: 'Gruppesupervision for fagpersoner',
      price: '1.250 kr.',
      duration: '3 timer pr. deltager',
      desc: 'Gruppesupervision i trygge rammer med 4-6 psykoterapeuter. Fysisk eller online.',
      conditions: 'Datoer annonceres løbende.',
      popular: false,
      bookingUrl: BOOKING_SUPERVISION_URL,
    },
  ];

  const coachingPrices = [
    {
      title: 'Coaching samtale',
      price: '1.500 kr.',
      duration: '60 min. pr. session (inkl. moms)',
      desc: 'Målrettet coaching for ledere og private. Tydeliggør mål og delmål, afdæk ressourcer og opbyg selvtillid til at handle.',
      conditions: 'Fysisk eller online via video.',
      popular: false,
      bookingUrl: BOOKING_THERAPY_URL,
    },
  ];

  return (
    <div className="bg-[#ECEEF1]">
      {/* Header */}
      <section className="py-16 sm:py-24 bg-white border-b border-[#D9DDE2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="max-w-3xl mx-auto">
            <span className="text-xs uppercase tracking-widest font-semibold text-[#5A232E] block mb-3">
              Investering i din trivsel
            </span>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#5A232E] tracking-tight">
              Gennemskuelige priser & forløb
            </h1>
            <p className="mt-5 text-base sm:text-lg text-[#6c7480] leading-relaxed">
              Ingen ubehagelige overraskelser. Du starter altid med en gratis 20 minutters afklaringssamtale og 100% tilfredshedsgaranti på din første session.
            </p>
          </div>
        </div>
      </section>

      {/* Gratis afklaringssamtale forklaring - Fremhævet konverteringsboks */}
      <section className="py-12 bg-[#D9DDE2] border-b border-[#D9DDE2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-3xl p-8 sm:p-10 border border-[#D9DDE2] shadow-sm">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 pb-6 border-b border-[#D9DDE2]">
              <div>
                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-semibold mb-2">
                  <i className="fa-solid fa-gift" aria-hidden="true" />
                  Altid 100% gratis
                </span>
                <h2 className="font-display text-2xl sm:text-3xl text-[#5A232E]">
                  Gratis afklaringssamtale (20 min.)
                </h2>
                <p className="text-xs sm:text-sm text-[#6c7480] mt-1">
                  Telefonisk eller online via video
                </p>
              </div>
              <a
                href={BOOKING_SCREENING_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('cta_booking_click', { location: 'pricing_free_call_box' })}
                className="px-6 py-3.5 rounded-xl bg-[#5A232E] hover:bg-[#431722] text-white font-semibold text-sm shadow-md transition-all no-break whitespace-nowrap"
              >
                <i className="fa-solid fa-calendar-check mr-2" aria-hidden="true" />
                Book afklaring nu
              </a>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-6 text-xs sm:text-sm text-[#11161d] leading-relaxed">
              <div>
                <strong className="block font-display text-[#5A232E] text-base mb-1">
                  Hvad er samtalen, og hvad taler man om?
                </strong>
                <p>
                  Vi taler kort og uformelt om, hvad du oplever i øjeblikket, og hvad du ønsker hjælp til. Du kan stille spørgsmål til metoderne og fornemme, hvordan jeg arbejder.
                </p>
              </div>
              <div>
                <strong className="block font-display text-[#5A232E] text-base mb-1">
                  Er man forpligtet til et forløb?
                </strong>
                <p>
                  Nej, absolut ikke. Samtalen er helt uforpligtende. Bagefter vurderer du i ro og mag, om du har lyst til at booke en første egentlig session.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tabs for Category Selection */}
      <section className="py-16 sm:py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center mb-12">
          {/* Mobile & Tablet Dropdown (< lg / 1024px) */}
          <div className="w-full max-w-xs lg:hidden">
            <label htmlFor="pricing-category-select" className="sr-only">
              Vælg ydelseskategori
            </label>
            <div className="relative">
              <select
                id="pricing-category-select"
                value={activeTab}
                onChange={(e) => setActiveTab(e.target.value)}
                className="w-full appearance-none bg-white text-[#11161d] font-semibold text-sm py-3.5 pl-5 pr-11 rounded-2xl border-2 border-[#D9DDE2] focus:border-[#5A232E] focus:outline-none shadow-xs transition-colors cursor-pointer"
              >
                <option value="terapi">Psykoterapi</option>
                <option value="hypnose">Hypnoterapi</option>
                <option value="supervision">Supervision</option>
                <option value="coaching">Coaching</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-[#5A232E]">
                <i className="fa-solid fa-chevron-down text-sm" aria-hidden="true" />
              </div>
            </div>
          </div>

          {/* Desktop Tabs (>= lg / 1024px) */}
          <div className="hidden lg:inline-flex p-1.5 rounded-2xl bg-white border border-[#D9DDE2] shadow-xs">
            {[
              { id: 'terapi', label: 'Psykoterapi' },
              { id: 'hypnose', label: 'Hypnoterapi' },
              { id: 'supervision', label: 'Supervision' },
              { id: 'coaching', label: 'Coaching' },
            ].map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={`px-5 py-2.5 rounded-xl text-sm font-semibold transition-all cursor-pointer ${
                  activeTab === tab.id
                    ? 'bg-[#5A232E] text-white shadow-xs'
                    : 'text-[#6c7480] hover:text-[#5A232E] hover:bg-[#ECEEF1]'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Pricing Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {activeTab === 'terapi' &&
            therapyPrices.map((item, idx) => (
              <div
                key={idx}
                className={`rounded-2xl p-7 border flex flex-col justify-between relative transition-all ${
                  item.popular
                    ? 'bg-[#5A232E] text-white border-2 border-[#5A232E] shadow-xl md:-translate-y-2 pt-8'
                    : 'bg-white text-[#11161d] border-[#D9DDE2] shadow-xs'
                }`}
              >
                {item.popular && (
                  <div className="absolute -top-3.5 right-6 bg-white text-[#5A232E] text-[11px] font-bold uppercase tracking-wider px-3.5 py-1 rounded-full shadow-md flex items-center gap-1.5 z-10 border border-[#5A232E]/20">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#5A232E]" />
                    Mest populære forløb
                  </div>
                )}
                <div>
                  <span className={`text-xs font-semibold uppercase tracking-wider ${item.popular ? 'text-[#D9DDE2]' : 'text-[#5A232E]'}`}>
                    {item.popular ? 'Klippekort (5 sessioner)' : idx === 0 ? 'Enkeltsession' : 'Særtilbud'}
                  </span>
                  <h3 className={`font-display text-2xl mt-1 mb-2 ${item.popular ? 'text-white' : 'text-[#5A232E]'}`}>
                    {item.title}
                  </h3>
                  <div className={`text-3xl font-display font-bold mb-1 ${item.popular ? 'text-white' : 'text-[#5A232E]'}`}>
                    {item.price}
                  </div>
                  <div className={`text-xs mb-4 ${item.popular ? 'text-[#D9DDE2]/80' : 'text-[#6c7480]'}`}>
                    {item.duration}
                  </div>
                  <p className={`text-xs leading-relaxed ${item.popular ? 'text-white/80' : 'text-[#6c7480]'}`}>
                    {item.desc}
                  </p>
                </div>

                <div className="mt-6 pt-4 border-t border-[#D9DDE2]/30">
                  <div className={`text-xs mb-4 ${item.popular ? 'border-white/20 text-[#D9DDE2]' : 'text-[#6c7480]'}`}>
                    {item.conditions}
                  </div>
                  <a
                    href={item.bookingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackEvent('cta_booking_click', { location: `pricing_${item.title}` })}
                    className={`w-full py-3 px-4 rounded-xl font-semibold text-xs flex items-center justify-center gap-2 transition-colors cursor-pointer no-break whitespace-nowrap ${
                      item.popular
                        ? 'bg-white hover:bg-[#ECEEF1] text-[#5A232E] shadow-md'
                        : 'bg-[#5A232E] hover:bg-[#431722] text-white'
                    }`}
                  >
                    <i className="fa-solid fa-calendar-check text-xs" aria-hidden="true" />
                    <span>Book session</span>
                  </a>
                </div>
              </div>
            ))}

          {activeTab === 'hypnose' &&
            hypnosisPrices.map((item, idx) => (
              <div
                key={idx}
                className={`rounded-2xl p-7 border flex flex-col justify-between relative transition-all ${
                  item.popular
                    ? 'bg-[#5A232E] text-white border-2 border-[#5A232E] shadow-xl md:-translate-y-2 pt-8'
                    : 'bg-white text-[#11161d] border-[#D9DDE2] shadow-xs'
                }`}
              >
                {item.popular && (
                  <div className="absolute -top-3.5 right-6 bg-white text-[#5A232E] text-[11px] font-bold uppercase tracking-wider px-3.5 py-1 rounded-full shadow-md flex items-center gap-1.5 z-10 border border-[#5A232E]/20">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#5A232E]" />
                    Mest populære forløb
                  </div>
                )}
                <div>
                  <span className={`text-xs font-semibold uppercase tracking-wider ${item.popular ? 'text-[#D9DDE2]' : 'text-[#5A232E]'}`}>
                    {item.badge || 'Hypnoterapi'}
                  </span>
                  <h3 className={`font-display text-2xl mt-1 mb-2 ${item.popular ? 'text-white' : 'text-[#5A232E]'}`}>
                    {item.title}
                  </h3>
                  <div className={`text-3xl font-display font-bold mb-1 ${item.popular ? 'text-white' : 'text-[#5A232E]'}`}>
                    {item.price}
                  </div>
                  <div className={`text-xs mb-4 ${item.popular ? 'text-[#D9DDE2]/80' : 'text-[#6c7480]'}`}>
                    {item.duration}
                  </div>
                  <p className={`text-xs leading-relaxed ${item.popular ? 'text-white/80' : 'text-[#6c7480]'}`}>
                    {item.desc}
                  </p>
                </div>

                <div className="mt-6 pt-4 border-t border-[#D9DDE2]/30">
                  <div className={`text-xs mb-4 ${item.popular ? 'border-white/20 text-[#D9DDE2]' : 'text-[#6c7480]'}`}>
                    {item.conditions}
                  </div>
                  <a
                    href={item.bookingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackEvent('cta_booking_click', { location: `pricing_${item.title}` })}
                    className={`w-full py-3 px-4 rounded-xl font-semibold text-xs flex items-center justify-center gap-2 transition-colors cursor-pointer no-break whitespace-nowrap ${
                      item.popular
                        ? 'bg-white hover:bg-[#ECEEF1] text-[#5A232E] shadow-md'
                        : 'bg-[#5A232E] hover:bg-[#431722] text-white'
                    }`}
                  >
                    <i className="fa-solid fa-calendar-check text-xs" aria-hidden="true" />
                    <span>Book session</span>
                  </a>
                </div>
              </div>
            ))}

          {activeTab === 'supervision' &&
            supervisionPrices.map((item, idx) => (
              <div
                key={idx}
                className="bg-white rounded-2xl p-7 border border-[#D9DDE2] shadow-xs flex flex-col justify-between"
              >
                <div>
                  <span className="text-xs font-semibold text-[#5A232E] uppercase tracking-wider">
                    Supervision
                  </span>
                  <h3 className="font-display text-2xl text-[#5A232E] mt-1 mb-2">{item.title}</h3>
                  <div className="text-3xl font-display font-bold text-[#5A232E] mb-1">
                    {item.price}
                  </div>
                  <div className="text-xs text-[#6c7480] mb-4">
                    {item.duration}
                  </div>
                  <p className="text-xs text-[#6c7480] leading-relaxed">
                    {item.desc}
                  </p>
                </div>

                <div className="mt-6 pt-4 border-t border-[#D9DDE2]">
                  <div className="text-xs text-[#6c7480] mb-4">
                    {item.conditions}
                  </div>
                  <a
                    href={item.bookingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full py-3 px-4 rounded-xl bg-[#5A232E] hover:bg-[#431722] text-white font-semibold text-xs flex items-center justify-center gap-2 transition-colors"
                  >
                    <i className="fa-solid fa-calendar-check text-xs" aria-hidden="true" />
                    <span>Book</span>
                  </a>
                </div>
              </div>
            ))}

          {activeTab === 'coaching' &&
            coachingPrices.map((item, idx) => (
              <div
                key={idx}
                className="bg-white rounded-2xl p-7 border border-[#D9DDE2] shadow-xs flex flex-col justify-between"
              >
                <div>
                  <span className="text-xs font-semibold text-[#5A232E] uppercase tracking-wider">
                    Coaching
                  </span>
                  <h3 className="font-display text-2xl text-[#5A232E] mt-1 mb-2">{item.title}</h3>
                  <div className="text-3xl font-display font-bold text-[#5A232E] mb-1">
                    {item.price}
                  </div>
                  <div className="text-xs text-[#6c7480] mb-4">
                    {item.duration}
                  </div>
                  <p className="text-xs text-[#6c7480] leading-relaxed">
                    {item.desc}
                  </p>
                </div>

                <div className="mt-6 pt-4 border-t border-[#D9DDE2]">
                  <div className="text-xs text-[#6c7480] mb-4">
                    {item.conditions}
                  </div>
                  <a
                    href={item.bookingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full py-3 px-4 rounded-xl bg-[#5A232E] hover:bg-[#431722] text-white font-semibold text-xs flex items-center justify-center gap-2 transition-colors"
                  >
                    <i className="fa-solid fa-calendar-check text-xs" aria-hidden="true" />
                    <span>Book session</span>
                  </a>
                </div>
              </div>
            ))}
        </div>

        {/* Betalings- og afbudsbetingelser */}
        <div className="mt-16 bg-white rounded-3xl p-8 border border-[#D9DDE2] shadow-xs space-y-4 text-xs sm:text-sm text-[#11161d] leading-relaxed">
          <h3 className="font-display text-xl text-[#5A232E]">Praktiske oplysninger</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-2">
            <div>
              <strong className="block text-[#5A232E] font-medium mb-1">Betalingsmuligheder:</strong>
              <p>Kortbetaling, MobilePay til <strong>113387</strong> eller bankoverførsel til reg.nr. 6194, kontonr. 4170756148.</p>
            </div>
            <div>
              <strong className="block text-[#5A232E] font-medium mb-1">Afbudspolitik:</strong>
              <p>Ved udeblivelse eller aflysning mindre end 24 timer før din aftalte tid, opkræves fuld betaling for sessionen.</p>
            </div>
          </div>
          <div className="pt-2">
            <button
              type="button"
              onClick={() => setIsGuaranteeOpen(true)}
              className="inline-flex items-center gap-1.5 text-xs text-[#5A232E] font-semibold underline hover:text-[#431722] cursor-pointer"
            >
              <i className="fa-solid fa-shield-check" aria-hidden="true" />
              Læs vilkår for 100% tilfredshedsgaranti på første session →
            </button>
          </div>
        </div>
      </section>

      <SatisfactionGuaranteeModal
        isOpen={isGuaranteeOpen}
        onClose={() => setIsGuaranteeOpen(false)}
      />
    </div>
  );
}
